import Store from '@/main/store';

import CheckoutRoutes from '@/app/features/Checkout/routes';
import CustomerRoutes from '@/app/features/Customer/routes';
import SuccessRoutes from '@/app/features/Success/routes';
import RedirectRoutes from '@/app/features/Redirect/routes';
import RecurrenceRoutes from '@/app/features/Recurrence/routes';

import NavigationGuard from '@/helpers/navigationGuard';

import { INavigationGuardRules } from '@/interfaces/NavigationGuard';

const navigationGuardRules: INavigationGuardRules = {
  private: 'payment',
  authentication: 'checkout',
};

export default [
  ...RedirectRoutes,
  ...NavigationGuard(navigationGuardRules, [
    ...SuccessRoutes,
    ...CustomerRoutes,
    ...CheckoutRoutes,
    ...RecurrenceRoutes,
  ]),
];
